var AssessmentViewService = require('services/assessment-service');
var CourseSettingsService = require('services/course-settings-service');

var AssessmentService = function() {
  this.triggerAssessment = function(blockView) {
    var url = AssessmentViewService.getUrl(blockView.model.get('assessment_slug'));
    if(url === undefined) {
      blockView.readyToGo();
      Chaplin.mediator.publish('page:navigate', 'forward');
    }
    else {
      setTimeout(_.bind(function() {
        Chaplin.mediator.publish('window:navigate', url);
      }, this), 2000);
    }
  };

  this.loadCourseAssessment = function(view) {
    view.assessment = AssessmentViewService.getAssessment(view.model.get('assessment_slug'));
    let failToLocal = CourseSettingsService.get('loadLocalAssessments');
    view.assessment.set('subtext', view.model.get('subtext'));
    return view.assessment.loadAssessment({
      split_questions: Boolean(view.model.get('split_questions')),
      failToLocal
    });
  };

  this.userHasCompletedAssessment = function(courseSlug, mapping) {
    return this.getActivityProgressForSlug(courseSlug, false, mapping).length > 0;
  };

  this.getBestScore = function(courseSlug, mapping) {
    var attempts = this.getActivityProgressForSlug(courseSlug, true, mapping);
    if(attempts.length === 0) {
      return null;
    } else {
      return _.max(attempts.map( function(attempt) { return attempt.get('grade'); }));
    }
  };

  this.getUrl = function(assessment) {
    return EF.url('/sdk/enrollments/' + EF.enrollment.get('id') + '/assessments/' + assessment.get('slug') + '.json');
  };

  this.isAttemptCorrect = function(results) {
    return results.last_answer_correct;
  };
  this.isAttemptComplete = function (attempt) {
    var questions = attempt.assessment.get('original_questions') || attempt.assessment.get('questions');
    return questions.every(function (q) {
      return !!(attempt.get(q.get('id')));
    });
  };

  this.isAttemptFinished = function (attempt) {
    return attempt.get('state') === 'passed' || attempt.get('state') === 'failed';
  };
  this.parseAttempt = function(data){
    return data;
  }

  this.refreshActivityProgress = function() {
    EF.activityProgresses.fetch();
  };

  this.getAssessmentStatus = function(courseSlug, mapping) {
    var attempts = this.getActivityProgressForSlug(courseSlug, true, mapping);
    if(attempts.length === 0) {
      return 'not-attempted';
    } else if(_.every(attempts, function(ap) { return !ap.get('passed'); })) {
      return 'failed';
    } else if(_.some(attempts, function(ap) { return ap.get('passed'); })) {
      return 'passed';
    }
  };

  this.getAssessmentActivity = function(courseSlug, mapping) {
    var activity = mapping[courseSlug];
    if(activity) {
      return activity;
    } else {
      console.warn('Invalid assessment mapping for slug: ', courseSlug); //eslint-disable-line no-console
      console.warn('Here are the configured assessment mappings for reference: ', mapping); //eslint-disable-line no-console
      // trigger something special...
    }
  };

  this.getActivityProgressForSlug = function(courseSlug, includeFailed, mapping) {
    if(EF.options.local) {
      return EF.activityProgresses.filter(function(ap) {
        return ap.get('slug') === courseSlug && (ap.get('passed') || includeFailed);
      });
    } else {
      var activity = this.getAssessmentActivity(courseSlug, mapping);
      return EF.activityProgresses.filter(function(ap) {
        return ap.get('activity_id') === activity.id && (ap.get('passed') || includeFailed);
      });
    }
  };

  this.getAttemptJSON = function(thisAttempt) {
    return {
     
      attempt: Backbone.Model.prototype.toJSON.apply(thisAttempt),
      force_grading: thisAttempt.get('force_grading'),
      data: {
        id: thisAttempt.get('id'),
        type: 'response_sets',
        attributes: {
          answers: [
            {
              question_id: thisAttempt.get('current_question_id'),
              value: thisAttempt.get(thisAttempt.get('current_question_id')),
              response_type: 'single_selection',
            },
          ],
        },
      },
    }
  }


};

module.exports = new AssessmentService();
